<template>
  <b-form @submit.prevent="send()">
    <div class="form-group">
      <label for>Placa</label>
      <v-select v-model="truck" :value="refueling.truck_id" :options="trucks" label="plate" :on-change="setTruck" ></v-select>
    </div>
    <div class="form-group">
      <label for>Lugar de abastecimiento</label>
      <input type="text" v-model="refueling.supply_place" class="form-control" />
    </div>
    <div class="form-group">
      <label for>Nombre operario</label>
      <input type="text" v-model="refueling.operator_name" class="form-control" />
    </div>
    <div class="form-group">
      <label for>Galonaje</label>
      <input type="number" v-model="refueling.gallons" class="form-control" required />
    </div>
    <div class="form-group">
      <label for>Odómetro (Kms)</label>
      <input type="number" v-model="refueling.km" class="form-control" required />
    </div>
    <div class="form-group">
      <label for>Guía de remisión</label>
      <input type="text" v-model="refueling.number_guide" class="form-control" required />
    </div>
    <div class="form-group">
      <label for>Número de vale</label>
      <input type="text" v-model="refueling.number_ticket" class="form-control" required />
    </div>
    <div class="form-group" v-if="refueling_id">
      <label for>Precio unitario</label>
      <input type="text" v-model="refueling.price_gallons" class="form-control" required />
    </div>
    <div class="form-group">
      <input type="submit" value="Enviar" class="btn btn-primary" />
    </div>
  </b-form>
</template>

<script>
import api from '@/helpers/api'
export default {
  name: 'form-fuel',
  props: ['refueling_id'],
  data(){
    return {
      trucks: [],
      truck: {},
      refueling: {}
    }
  },
  watch:{
    refueling_id: function(new_val, old_val){
      this.getRefueling(new_val)
    }
  },
  mounted(){
    api.get(`/trucks`).then(response => {
      this.trucks = response.trucks;
    });
  },
  methods: {
    getRefueling(refueling_id){
      if(refueling_id){
        api.get(`/refueling/${refueling_id}`).then(response => {
          this.refueling = response.refueling
          this.truck = this.trucks.find(t => t.id == this.refueling.truck_id)
        })
      }
    },
    setTruck(obj) {
      this.truck = obj ? obj : {};
      this.refueling.truck_id = obj ? obj.id : null
    },
    send() {

      delete this.refueling.created_at
      delete this.refueling.updated_at
      if(this.refueling_id){
        api.put(`/refueling/${this.refueling_id}`, this.refueling).then(response => {
          this.refueling = {}
          this.$toastr.success("Registro actualizado exitosamente", "Proveedor", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          this.$emit('update', response.refueling)
        }).catch(message => {
          this.$toastr.error(message, "Proveedor", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        });;
      } else {
        api.post("/refuelings", this.refueling).then(response => {
          this.refueling = {}
          this.$toastr.success("Registro creado exitosamente", "Proveedor", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          // this.$emit('update', response.refueling)
        }).catch(message => {
          this.$toastr.error(message, "Proveedor", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        });
      }
    },
  }
}
</script>